import { Component, Input, input, output } from '@angular/core';
import { Time } from '@angular/common';
import { CalendarComponent } from '../calendar/calendar.component';
import { CalendarTimerComponent } from '../calendar-timer/calendar-timer.component';

@Component({
  selector: 'ui-date-time-picker',
  imports: [CalendarComponent, CalendarTimerComponent],
  templateUrl: './date-time-picker.component.html',
})
export class DateTimePickerComponent {
  readonly isOpenSpace = input(false);
  readonly time = input.required<{
    hour: number;
    minute: number;
  }>();
  readonly availableSlots = input<
    {
      startTime: string;
      endTime: string;
    }[]
  >([]);
  @Input() selectedDate: Date = new Date();
  readonly maxNumberOfHours = input(1);
  readonly counterNumber = input.required<number>();
  readonly dayToDisable = input<Date[]>();

  readonly currentDate = output<Date>();
  readonly numberHoursEmitter = output<number>();
  readonly currentTime = output<{
    hour: number;
    minute: number;
  }>();

  getSelectedDate(event: Date) {
    this.selectedDate = event;
    this.currentDate.emit(event);
  }

  getCurrentTime(event: { hour: number; minute: number }) {
    this.currentTime.emit(event);
  }

  getNumbersHours(event: number) {
    console.log('date-time event', event);
    this.numberHoursEmitter.emit(event);
  }
}
